import { timestampDate, timestampFromDate } from '@bufbuild/protobuf/wkt';
import { Client } from '@connectrpc/connect';

import { LFDOverridesService } from './espb/lfd_overrides_service_pb';
import { requireFieldNotEmpty } from './grpcUtils';

export default class LFDOverridesClient {
  constructor(private readonly espbClient: Client<typeof LFDOverridesService>) {}

  async list(lastKnownOverridesUpdateTime?: Date): Promise<{
    overridesJson: string[];
    overridesUpdateTime: Date;
  }> {
    const resp = await this.espbClient.list({
      lastKnownOverridesUpdateTime:
        lastKnownOverridesUpdateTime ? timestampFromDate(lastKnownOverridesUpdateTime) : undefined,
    });
    return {
      overridesJson: resp.overridesJson,
      overridesUpdateTime: timestampDate(requireFieldNotEmpty(resp.overridesUpdateTime)),
    };
  }
}
